import { render, staticRenderFns } from "./SiloDrawer.vue?vue&type=template&id=756f4936&scoped=true"
import script from "./SiloDrawer.vue?vue&type=script&lang=js"
export * from "./SiloDrawer.vue?vue&type=script&lang=js"
import style0 from "./SiloDrawer.vue?vue&type=style&index=0&id=756f4936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f4936",
  null
  
)

export default component.exports